var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialogHeader comp",attrs:{"flex":"main:justify cross:center"}},[_c('div',{staticClass:"text",attrs:{"flex":"cross:center"}},[_vm._v(_vm._s(_vm.title))]),_c('img',{staticClass:"close_icon",attrs:{"src":require("../../assets/image/pft_icon_close.png")},on:{"click":_vm.closeDialog}})])
}
var staticRenderFns = []

export { render, staticRenderFns }